import * as React from 'react';
import { st, classes } from './Tooltip.st.css';
import './Tooltip.responsive.st.css';
import { Tooltip as BaseTooltip, } from '../../floating-ui';
import Text from '../Text';
import { BaseUiNextContext } from '../../utils/BaseUINextContext';
import responsive from '../../utils/skins/responsive';
const Tooltip = ({ dataHook, content, children, placement = 'top', hideArrow = false, delay, }) => {
    const context = React.useContext(BaseUiNextContext);
    const isResponsive = context?.theme === 'responsive';
    const shouldHideArrow = isResponsive || hideArrow;
    const renderContent = (_content) => {
        if (typeof _content === 'string') {
            return (React.createElement(Text, { key: _content, size: "small", weight: "thin", skin: "secondary" }, _content));
        }
        if (Array.isArray(_content)) {
            return _content.map((c) => renderContent(c));
        }
        return _content;
    };
    return (React.createElement(BaseTooltip, { content: content ? (React.createElement("div", { className: st(classes.contentContainer) }, renderContent(content))) : null, placement: placement, hideArrow: shouldHideArrow, offset: shouldHideArrow ? 4 : 13, delay: delay, floatingElementProps: {
            dataHook,
            className: st(classes.root, isResponsive && responsive({ darkMode: context?.darkMode }), context.appFlagsClass),
            arrowClassName: shouldHideArrow ? '' : classes.arrow,
        } }, (refs) => (typeof children === 'function' ? children(refs) : children)));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map